/**
 * ChurnZero JavaScript SDK helper module.
 * Follows the same pattern as amplitudeHelper.js for third-party integration.
 */

/**
 * Dynamically injects the ChurnZero script tag into <head>.
 * Same pattern as ContentSquare loading in AppWrapper.js.
 */
export const loadChurnZeroScript = () => {
  if (document.getElementById('churnzero-script')) return;

  // ChurnZero SDK bootstrap: create the global push array before the script loads
  window.ChurnZero = window.ChurnZero || [];

  const script = document.createElement('script');
  script.id = 'churnzero-script';
  script.src = 'https://teambuildr.us1app.churnzero.net/churnzero.js';
  script.async = true;
  document.head.appendChild(script);
};

/**
 * Initializes ChurnZero with app key and contact identification.
 */
export const initChurnZero = (appKey, accountExternalId, contactExternalId) => {
  if (!window.ChurnZero) return;
  window.ChurnZero.push(['setAppKey', appKey]);
  window.ChurnZero.push(['setContact', accountExternalId, contactExternalId]);
};

/**
 * Tracks a ChurnZero event.
 * @param {string} eventName - Name of the event
 * @param {string} [description=''] - Event description
 * @param {number} [quantity=1] - Event quantity/count
 * @param {object} [customFields={}] - Additional custom fields
 */
export const trackCZEvent = (eventName, description = '', quantity = 1, customFields = {}) => {
  if (!window.ChurnZero) return;
  window.ChurnZero.push(['trackEvent', eventName, description, quantity, customFields]);
};

/**
 * Sets a ChurnZero attribute on a contact or account.
 * Supports both single attribute and batch (object) modes.
 * @param {'contact'|'account'} entity - The entity type
 * @param {string|object} nameOrBatch - Attribute name (string) or batch object of key-value pairs
 * @param {*} [value] - Attribute value (only used when nameOrBatch is a string)
 */
export const setCZAttribute = (entity, nameOrBatch, value) => {
  if (!window.ChurnZero) return;
  if (typeof nameOrBatch === 'object') {
    window.ChurnZero.push(['setAttribute', entity, nameOrBatch]);
  } else {
    window.ChurnZero.push(['setAttribute', entity, nameOrBatch, value]);
  }
};

/**
 * Sets the current module for time-in-app tracking.
 * @param {string} moduleName - The module name to track
 */
export const setCZModule = (moduleName) => {
  if (!window.ChurnZero) return;
  window.ChurnZero.push(['setModule', moduleName]);
};

/**
 * Stops the ChurnZero session (call on logout).
 */
export const stopChurnZero = () => {
  if (!window.ChurnZero) return;
  window.ChurnZero.push(['stop']);
};
